import { useState, type FormEvent } from 'react';
import styles from './AccessPasswordSettings.module.css';

const MIN_LENGTH = 6;

interface Props {
  enabled: boolean;
  /** `null` remove a senha. */
  onSave(password: string | null): Promise<void>;
}

export function AccessPasswordSettings({ enabled, onSave }: Props) {
  const [editing, setEditing] = useState(false);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  async function save(value: string | null) {
    setSaving(true);
    setError(null);
    try {
      await onSave(value);
      setEditing(false);
      setPassword('');
      setConfirm('');
    } catch (err) {
      setError(String(err));
    } finally {
      setSaving(false);
    }
  }

  function submit(e: FormEvent) {
    e.preventDefault();
    if (password.length < MIN_LENGTH) return setError(`A senha precisa ter pelo menos ${MIN_LENGTH} caracteres.`);
    if (password !== confirm) return setError('As senhas não conferem.');
    void save(password);
  }

  function cancel() {
    setEditing(false);
    setPassword('');
    setConfirm('');
    setError(null);
  }

  if (editing) {
    return (
      <form className={styles.form} onSubmit={submit}>
        <input
          className={styles.input}
          type="password"
          placeholder="Nova senha"
          autoComplete="new-password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          className={styles.input}
          type="password"
          placeholder="Confirmar senha"
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
        {error && <p className={styles.error}>{error}</p>}
        <div className={styles.actions}>
          <button type="button" className={styles.secondary} onClick={cancel} disabled={saving}>
            Cancelar
          </button>
          <button type="submit" className={styles.primary} disabled={saving}>
            {saving ? 'Salvando...' : 'Salvar senha'}
          </button>
        </div>
      </form>
    );
  }

  return (
    <div>
      <div className={styles.row}>
        <p className={styles.statusLine}>
          Senha de acesso: <span className={styles.statusValue}>{enabled ? 'Ativada' : 'Desativada'}</span>
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.secondary} onClick={() => setEditing(true)} disabled={saving}>
            {enabled ? 'Alterar senha' : 'Definir senha'}
          </button>
          {enabled && (
            <button type="button" className={styles.danger} onClick={() => void save(null)} disabled={saving}>
              Remover senha
            </button>
          )}
        </div>
      </div>
      <p className={styles.helper}>
        {enabled
          ? 'Quem souber a senha entra sem você precisar aceitar.'
          : 'Toda conexão precisa ser aceita aqui.'}
      </p>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}
